import { render, staticRenderFns } from "./Concluir.vue?vue&type=template&id=8d7d372c&scoped=true"
import script from "./Concluir.vue?vue&type=script&lang=js"
export * from "./Concluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7d372c",
  null
  
)

export default component.exports